import * as React from "react";

interface ImageProps {
    imageUrl?: string;
}

export const Image = (props: ImageProps) => {
    const { imageUrl } = props;
    const style = { backgroundImage: imageUrl, backgroundSize: "contain", width: "100%", height: "100%" };

    return <div style={style} />;
};
